import angular from 'angular';
import MassiaSelectController from './components/massia-select/massia.select.controller';
import MassiaSelectService from './components/massia-select/services/massia.select.service';
import MassiaDateController from './components/massia-date/massia.date.controller';
import MassiaDateService from './components/massia-date/services/massia.date.service';
import MassiaOnoffController from './components/massia-onoff/massia.onoff.controller';
import MassiaInputController from './components/massia-input/massia.input.controller';
import MassiaValidateController from './components/massia-validate/massia.validate.controller';
import MassiaValidateService from './components/massia-validate/services/massia.validate.service';

import MassiaSelectTemplete from './components/massia-select/massia.select.html';
import MassiaDateTemplete from './components/massia-date/massia.date.html';
import MassiaInputTemplete from './components/massia-input/massia.input.html';
import MassiaOnOffTemplete from './components/massia-onoff/massia.onoff.html';
import MassiaValidateTemplete from './components/massia-validate/massia.validate.html';

angular.module('sharedService', []).service('SharedDataService', [
	'$rootScope',
	function ($rootScope) {
		var data = {};

		function setData(key, valueObject) {
			data[key] = valueObject;
			$rootScope.$broadcast(key + 'Changed', valueObject);
		}

		function setAllData(dataObject) {
			data = dataObject;
			for (var key in dataObject) {
				if (Object.prototype.hasOwnProperty.call(dataObject, key)) {
					$rootScope.$broadcast(key + 'Changed', dataObject[key]);
				}
			}
		}

		function getAllData() {
			return data;
		}

		function getData(key) {
			return data[key];
		}

		function listenData(key, callback) {
			$rootScope.$on(key + 'Changed', function (event, newValue, oldValue) {
				callback(newValue, oldValue);
			});
		}

		return {
			setData: setData,
			setAllData: setAllData,
			getData: getData,
			getAllData: getAllData,
			listenData: listenData
		};
	}
]);

angular
	.module('massiaSelect', ['sharedService'])
	.controller('MassiaSelectController', MassiaSelectController)
	.service('MassiaSelectService', MassiaSelectService)
	.directive('massiaSelect', function () {
		return {
			restrict: 'E',
			scope: {
				ngModel: '=',
				help: '<?',
				options: '<?',
				config: '<?',
				placeholder: '@',
				onSelect: '&'
			},
			template: MassiaSelectTemplete,
			controller: 'MassiaSelectController',
			controllerAs: '$ctrl',
			bindToController: true
		};
	});

angular
	.module('massiaDate', ['sharedService'])
	.controller('MassiaDateController', MassiaDateController)
	.service('MassiaDateService', MassiaDateService)
	.directive('massiaDate', function () {
		return {
			restrict: 'E',
			scope: {
				ngModel: '=',
				help: '<?',
				options: '<?',
				config: '<?',
				onSelect: '&'
			},
			template: MassiaDateTemplete,
			controller: 'MassiaDateController',
			controllerAs: '$ctrl',
			bindToController: true
		};
	});

angular
	.module('massiaOnoff', ['sharedService'])
	.controller('MassiaOnoffController', MassiaOnoffController)
	.directive('massiaOnoff', function () {
		return {
			restrict: 'E',
			scope: {
				ngModel: '=',
				help: '<?',
				options: '<?',
				config: '<?',
				onSelect: '&'
			},
			template: MassiaOnOffTemplete,
			controller: 'MassiaOnoffController',
			controllerAs: '$ctrl',
			bindToController: true
		};
	});

angular
	.module('massiaInput', ['sharedService'])
	.controller('MassiaInputController', MassiaInputController)
	.directive('massiaInput', function () {
		return {
			restrict: 'E',
			scope: {
				ngModel: '=',
				help: '<?',
				options: '<?',
				config: '<?',
				onSelect: '&'
			},
			template: MassiaInputTemplete,
			controller: 'MassiaInputController',
			controllerAs: '$ctrl',
			bindToController: true
		};
	});

///////////////////////////////////////////////////////////////////////////////////////////////
/////////                  BOUTON DE VALIDATION DU FORMULAIRE                            //////
///////////////////////////////////////////////////////////////////////////////////////////////

angular
	.module('massiaValidate', ['sharedService'])
	.controller('MassiaValidateController', MassiaValidateController)
	.service('MassiaValidateService', MassiaValidateService)
	.directive('massiaValidate', function () {
		return {
			restrict: 'E',
			scope: {
				config: '<?',
				help: '<?',
				onValidate: '&'
			},
			transclude: true,
			template: MassiaValidateTemplete,
			controller: 'MassiaValidateController',
			controllerAs: '$ctrl',
			bindToController: true
		};
	});

angular
	.module('formApp', ['massiaSelect', 'massiaDate', 'massiaInput', 'massiaOnoff', 'massiaValidate'])
	.controller('MainController', function () {})
	.controller('MassiaValidateController', MassiaValidateController)
	.controller('MassiaDateController', MassiaDateController)
	.controller('MassiaSelectController', MassiaSelectController)
	.controller('MassiaInputController', MassiaInputController)
	.controller('MassiaOnOffController', MassiaOnoffController);

export default 'formApp';
